<script lang="ts">
  import { activeTab, canAdmin, isAdmin, AUTH_REQUIRED } from "../lib/stores";

  type TabName = "analysis" | "lean" | "wbs" | "risks" | "briefing" | "users";
  const tabs: { name: TabName; label: string }[] = [
    { name: "analysis", label: "Analysis" },
    { name: "lean", label: "Lean planning" },
    { name: "wbs", label: "WBS" },
    { name: "risks", label: "Risk register" },
    { name: "briefing", label: "Management summary" },
  ];

  function select(name: TabName) {
    if (name === "users" && !AUTH_REQUIRED) return;
    if (name === "users" && !isAdmin()) return;
    activeTab.set(name);
  }

  // User management only makes sense against a real backend.
  $: showUsers = AUTH_REQUIRED && $canAdmin;
</script>

<div class="tabbar" role="tablist">
  {#each tabs as t}
    <button class="tab-btn" class:active={$activeTab === t.name} type="button" on:click={() => select(t.name)}>
      {t.label}
    </button>
  {/each}
  {#if showUsers}
    <button class="tab-btn" class:active={$activeTab === "users"} type="button" on:click={() => select("users")}>
      Users
    </button>
  {/if}
</div>
